import { Button, DialogActions } from '@material-ui/core';
import languageValues from 'utils/LanguageUtils';
import { ModalRemoveCoopProps } from '../ModalAddCoop/DocumentCoop/__types';
import './index.scss';
import CheckIcon from 'components/Icons/CheckIcon';

export const ModalRemoveCoop: React.FC<ModalRemoveCoopProps> = ({
  onCancel,
  onConfirm,
}) => {
  return (
    <div>
      <p className='form-remove-coop__dialog-content'>{languageValues.pages.escolas.modals.removerCoopModal.text}</p>
      <DialogActions className='form-remove-coop__dialog-actions'>
        <Button className='btnClose' onClick={onCancel}>
          {languageValues.pages.escolas.buttons.cancelar}
        </Button>
        <Button
          className='btnExit'
          endIcon={<CheckIcon />}
          onClick={onConfirm}
        >
          {languageValues.pages.escolas.buttons.remover}
        </Button>
      </DialogActions>
    </div>
  );
};
